// NOTE: Deprecated, use uiLibrary/Inputs/Checkbox instead
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import classnames from 'classnames';
import Checkbox from '../Inputs/Checkbox';

import classes from './CheckBox.module.scss';

const CheckBox = ({ checked, onChange, disabled, id = 'checkboxInput', name, className }) => (
  <Checkbox
    id={id}
    name={name || id}
    checked={checked}
    onChange={onChange}
    disabled={disabled}
    className={classnames(classes.root, { [className]: !!className })}
  />
);

export default CheckBox;
